export default "__VITE_ASSET__6d0bb1da__"